import React from "react";
import { Button } from "grommet";
import { ANTI_DOPING_LINK } from "../../../mocks/antiDopingLinks";
import { StyledBox } from "./styles";
export var ButtonGroup = function ButtonGroup() {
  return /*#__PURE__*/ React.createElement(
    StyledBox,
    {
      align: "start",
      direction: "row",
      gap: "small",
      margin: {
        bottom: "large",
      },
    },
    ANTI_DOPING_LINK.map(function (l) {
      return /*#__PURE__*/ React.createElement(Button, {
        key: l.link,
        href: l.link,
        primary: true,
        margin: {
          top: "small",
        },
        label: l.label,
      });
    })
  );
};
